import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {
  static values = {
    seriesData: Array,
    categoriesType: String,
    title: String,
  };

  connect() {
    this.renderChart();

    // document.onreadystatechange = () => {
    //   if (document.readyState === "complete") {
    //     console.log("Document is ready");
    //     this.renderChart();
    //   }
    // };
  }

  renderChart() {
    var categories = (this.categoriesTypeValue ?? "").includes("year")
      ? [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ]
      : ["Week 1", "Week 2", "Week 3", "Week 4"];

    var options = {
      chart: {
        height: "100%",
        maxWidth: "100%",
        type: "bar",
        fontFamily: "Inter, sans-serif",
        dropShadow: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      colors: ["#16a249", "#f59e0b", "#3b82f6", "#d946ef", "#f43f5e"],
      // tooltip: {
      //   enabled: true,
      //   x: {
      //     show: false,
      //   },
      // },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      grid: {
        show: false,
        strokeDashArray: 4,
        padding: {
          left: 2,
          right: 2,
          top: 0,
        },
      },
      series: this.seriesDataValue ?? [],
      xaxis: {
        categories,
      },
      yaxis: {
        title: {
          text: "EUR",
        },
      },
    };

    var chart = new ApexCharts(this.element, options);
    chart.render();
  }
}
